<template>
    <div class="circle-node" :class="[nodeType, { 'start': nodeType === 'start', 'end': nodeType === 'end' }]">
        <div class="label">{{ label }}</div>

        <!-- Start Node has only Source (bottom) -->
        <Handle v-if="nodeType === 'start'" type="source" position="bottom" class="custom-handle" />

        <!-- End Node has only Target (top) -->
        <Handle v-if="nodeType === 'end'" type="target" position="top" class="custom-handle" />
    </div>
</template>

<script>
import { Handle } from '@vue-flow/core'

export default {
    name: 'CircleNode',
    components: {
        Handle
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
        label: {
            type: String,
            default: 'Node'
        }
    },
    computed: {
        nodeType() {
            return this.data.type || 'start'; // 'start' or 'end'
        }
    }
}
</script>

<style scoped>
.circle-node {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: 2px solid #333;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    background: white;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    font-size: 12px;
    font-weight: bold;
    color: #333;
}

.circle-node.start {
    border-color: #4caf50;
    color: #2e7d32;
    background: #e8f5e9;
}

.circle-node.end {
    border-color: #f44336;
    color: #c62828;
    background: #ffebee;
}

.custom-handle {
    width: 10px;
    height: 10px;
    background: #555;
}

.circle-node.start .custom-handle {
    background: #4caf50;
}

.circle-node.end .custom-handle {
    background: #f44336;
}
</style>
